export default function HowItWorks() {
  const steps = [
    {
      num: "01",
      title: "Browse structured product spreadsheet",
      desc: "Access the organized itaobuy spreadsheet system with 14 product categories, all pre-arranged for quick scanning.",
      icon: "ri-search-eye-line",
    },
    {
      num: "02",
      title: "Compare suppliers & prices instantly",
      desc: "Review side-by-side supplier data and pricing information without switching between multiple tabs or windows.",
      icon: "ri-scales-3-line",
    },
    {
      num: "03",
      title: "Click & redirect to purchase system",
      desc: "Once you find what you need, one click takes you to the secure purchasing platform to complete your order.",
      icon: "ri-shopping-cart-2-line",
    },
  ];

  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-12">
          <p className="text-xs md:text-sm font-medium text-foreground-500 tracking-[0.15em] uppercase mb-3 whitespace-nowrap">
            Simple Process
          </p>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-[1.15]">
            How ItaobuySpreadsheet Works
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          {steps.map((step) => (
            <div key={step.num} className="text-center group">
              <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center rounded-2xl bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${step.icon} text-2xl`}></i>
              </div>
              <div className="text-xs font-bold text-accent-400 mb-2 whitespace-nowrap">{step.num}</div>
              <h3 className="text-lg font-semibold text-foreground-950 mb-2 whitespace-nowrap">{step.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed max-w-xs mx-auto">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}